import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import React from "react";

export default function DifficultyLevelPolicyDialog({ open, onClose }) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="sm"
            fullWidth
        >
            <DialogTitle sx={{ m: 0, p: 2, position: 'relative' }}>
                Difficulty Level Policies
                {onClose ? (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon />
                    </IconButton>
                ) : null}
            </DialogTitle>
            <DialogContent>
                <Box sx={{ p: 1 }}>
                    <Typography variant="body2" sx={{ display: 'block', mb: 1.5 }}>
                        • <strong>Reverse word probability:</strong> 0.5 (50% chance that a word is reversed)
                    </Typography>
                    <Typography variant="body2" sx={{ display: 'block', mb: 1.5 }}>
                        • <strong>Hard score min:</strong> 50 (words with score &lt; 50 are excluded from MEDIUM/HARD puzzles)
                    </Typography>
                    <Typography variant="body2" sx={{ display: 'block', mb: 1.5 }}>
                        • <strong>Hard score max:</strong> 219 (Hard: ≤ 219)
                    </Typography>
                    <Typography variant="body2" sx={{ display: 'block', mb: 1.5 }}>
                        • <strong>Low score threshold percent:</strong> 60.0% (percentage of low-score words to mark puzzle as 'HARD')
                    </Typography>
                    <Typography variant="body2" sx={{ display: 'block', mb: 1.5 }}>
                        • <strong>Easy score min:</strong> 850 (Easy: score ≥ 850)
                    </Typography>
                    <Typography variant="body2" sx={{ display: 'block', mb: 1.5 }}>
                        • <strong>Easy score max:</strong> 100000 (Reject: &gt; 100000)
                    </Typography>
                    <Typography variant="body2" sx={{ display: 'block', mb: 1.5 }}>
                        • <strong>Easy score threshold percent:</strong> 50.0% (percentage of easy-score words to mark puzzle as 'EASY')
                    </Typography>
                    <Typography variant="body2" sx={{ display: 'block', mb: 1.5 }}>
                        • <strong>Medium score min:</strong> 220 (Medium: 220-849)
                    </Typography>
                    <Typography variant="body2" sx={{ display: 'block', mb: 1.5 }}>
                        • <strong>Medium score max:</strong> 849 (Medium: 220-849)
                    </Typography>
                    <Typography variant="body2" sx={{ display: 'block', mb: 1.5 }}>
                        • <strong>Min word length:</strong> 4 (words shorter than this length are ignored)
                    </Typography>
                    <Typography variant="body2" sx={{ display: 'block', mb: 1.5 }}>
                        • <strong>Min words threshold:</strong> 15 (minimum number of words required to form a valid puzzle)
                    </Typography>
                    <Typography variant="body2" sx={{ display: 'block', mb: 1.5 }}>
                        • <strong>Word network thresholds:</strong>
                    </Typography>
                    <Typography variant="body2" sx={{ display: 'block', ml: 2, mb: 1.5 }}>
                        - <strong>Syntactic dependency:</strong> 0.0 (threshold for syntactic dependency links)
                    </Typography>
                    <Typography variant="body2" sx={{ display: 'block', ml: 2 }}>
                        - <strong>Semantic similarity:</strong> 0.5 (threshold for semantic similarity links)
                    </Typography>
                </Box>
            </DialogContent>
        </Dialog>
    );
}

